import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import PinIcon from "@entrilia/shared/icons/PinIcon.tsx";

interface Props {
  label: string;
  freezeColumn: (event: React.MouseEvent<HTMLElement>) => void;
}

const FreezeMenuItem = ({ label, freezeColumn }: Props) => {
  return (
    <MenuItem onClick={freezeColumn}>
      <ListItemIcon>
        <PinIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText>{label}</ListItemText>
    </MenuItem>
  );
};

export default FreezeMenuItem;
